export default {
  setUserApplications(state, payload) {
    state.applications = payload
  },
}
